import * as d3 from "d3";
import $ from "jquery";
import {
  abolishInvalidGroups,
  adjustCenter,
  plannerCanvasHeight,
  AnyLineIntersectsARoomMod,
  AnyLineIntersectsSelfMod,
  cleanupMethods,
  convertPoly,
  convertWallMods,
  correctPos,
  deleteFloor,
  devicesChanged,
  downloadImages,
  draw_groupMeMove,
  draw_mouseMove,
  enablePlannerButtons,
  filterInvalidDevices,
  getViewBoxElem,
  highlightNextProblematic,
  highlightPoint,
  initScaleLineInput,
  isCurrentlyAutoPanning,
  isPlannerVisible,
  isPointAvailable,
  isSecretPlanner,
  modifyWallsOfRoom,
  modifyWallStartPoint,
  plannerSVGMouseDownHandler,
  processMats,
  pureRecalcDevSize,
  recalcAllRoomsDynamicProps,
  recalcBaseDevSize,
  redrawModifyCircles,
  redrawModifyPolyline,
  redrawRooms,
  resetSizeErrorHelper,
  roomContainsAnother,
  rotateMeUpdate,
  saveOpacity,
  setMode,
  setPageXY,
  setPlanNamesShown,
  showActualSizeBtn,
  showCurrLeftouts,
  toggleEditableWallViewMode,
  toggleZenMode,
  toolbarSwitchSet,
  zenModeOff,
  zenModeOn,
  zoomed,
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {degToRad, uMath, XYtoNumPoly} from "src/components/Planner/planner/uMath";
import {
  canModifyProjectByProjectId,
  ControllerGlobals,
  FULL_SCREEN_OFF_ICON,
  FULL_SCREEN_ON_ICON,
  getAuthHeader,
  getMeasurementSystem,
  isMobile,
  MODKEYS_STATE,
  plannerOpenedDeferred,
  toastInfo,
  toastInfoSingle,
  toastRemoveAll
} from "src/components/Planner/controller";
import {ts} from "src/utils/translate";
import {getDeviceById, rebuildWallsCache, uDev, UDevGlobals} from "src/components/Planner/planner/uDev";
import {uDevDOM} from "src/components/Planner/planner/uDev-dom";
import {
  entitySelectUpdate,
  redrawWallSelectLine,
  wallSelectUpdate
} from "src/components/Planner/planner/wallModHelper-dom";
import {PLANNER_WIZARD, WizardGlobals} from "src/components/Planner/planner/wizard";
import {dragNote, dragNoteEnd, dragNoteStarted, redrawNotes} from "src/components/Planner/planner/notes";
import {dragdev, dragended, dragstarted, roomCircleDragHandler} from "src/components/Planner/planner/draganddrop";
import {
  drawOuterWallModifyCircles,
  drawOuterWallModifyPolyline,
  instantCalcOuter
} from "src/components/Planner/planner/outerwall";
import {ROOT_URI} from "src/utils/constants";
import {PlannerHistoryManager} from "src/components/Planner/planner/history";
import {MovsenGlobals} from "src/components/Planner/planner/movsen-globals";
import {convertMeasurements, draw_measureMeMove, measureHelper} from "src/components/Planner/planner/measurement";
import {WallSegmentation} from "src/components/Planner/planner/wallSegmentation";
import {WIFICALC} from "src/components/Planner/planner/wificalc";
import {removeWifiHeatmap} from "src/components/Planner/planner/wificalc-dom";
import {LightingCalcTransfer} from "src/components/Planner/planner/lightingCalc";
import {GroupingGlobals} from "src/components/Planner/planner/grouping";
import {getFrontendURL} from "src/utils/url";
import {initGlobalEvents} from "src/components/Planner/planner/initGlobalEvents";
import noUiSlider from "nouislider";
import {deviceProvider} from "src/components/Planner/planner/DeviceProvider";

let pictureDragBehavior = null;
let dragging = null;
export let plannerOverlayTimeout = null;
let planner_minZoom = 1;

export function plannerInitGlobals() {
  //setting up d3 behavior
  PlannerGlobals.zoom = d3.zoom()
  .scaleExtent([planner_minZoom, PlannerGlobals.planner_maxZoom])
  .on("zoom", zoomed);

  /**
   * Defines the behavior of the SVG element's panning/dragging
   */
  PlannerGlobals.drag = d3.drag()
  .filter(function (event) {
    if (PlannerGlobals.mode === 'groupMe' || PlannerGlobals.mode === 'rotateMe') {
      return false;
    }
    return !event.ctrlKey && !event.button;
  })
  .subject(function (event, d) {
    return {
      x: d.x,
      y: d.y
    };
  })
  .on("start", dragstarted)
  .on("drag", dragdev)
  .on("end", dragended);


  /**
   * Starting the drag of a circle for modifying the room
   */
  PlannerGlobals.dragRoomCircle = d3.drag()
  .on("start", function (event, d) {
    // Midpoint detection: insert point into polygon before drag begins
    if (d.wallIndex !== undefined) {
      var wallIndex = d.wallIndex;
      var walls = modifyWallsOfRoom(PlannerGlobals.modifiedRoom);
      PlannerGlobals.changedWalls[walls[wallIndex].id + ""] = true;
      PlannerGlobals.modifiedPoly.splice(wallIndex + 1, 0, d);
      PlannerGlobals.selectRoomUndoArr.push(wallIndex);
      delete d.wallIndex;
      redrawModifyPolyline();
    }
    PlannerGlobals.draggingRoomCircle = true;
    PlannerGlobals.draggedRoomCircle = d;
    PlannerGlobals.draggingSomething = true;
    PlannerGlobals.leftoutAlertShown = false;
    //hide the circles while dragging them
    d3.select('.modifyCircles').style('visibility', 'hidden');
    /* $('#plannerIMAGE').css('cursor', 'none'); */
    if (d.tx == undefined) {
      d.tx = 0;
      d.ty = 0;
    }
    //state of the circle before dragging, so it can be restored
    PlannerGlobals.dragstartState.tx = d.tx;
    PlannerGlobals.dragstartState.ty = d.ty;
    PlannerGlobals.dragstartState.x = d.x;
    PlannerGlobals.dragstartState.y = d.y;
    PlannerGlobals.draggedWall = modifyWallStartPoint(d);
  })
  //done on every frame the circle is dragged
  .on("drag", roomCircleDragHandler)
  //runs when the circle is released
  .on("end", function (event, d) {
    enablePlannerButtons();
    PlannerGlobals.draggingRoomCircle = false;
    PlannerGlobals.draggedRoomCircle = null;
    PlannerGlobals.draggingSomething = false;
    if (!PlannerGlobals.modifiedRoom) {
      return;
    }
    PlannerGlobals.modifiedRoom.poly = PlannerGlobals.modifiedPoly;
    //checking if the room conforms to the rules
    var normalModroomPoly = XYtoNumPoly(PlannerGlobals.modifiedPoly);

    var preventMod = false;
    var testRes;

    if (!isPointAvailable([d.x, d.y])) {
      if (PlannerGlobals.mode == 'drawOuterW') {
        toastInfo(ts('p_ow_point_in_room_err', "You cannot place a wall there."));
      }
      else {
        toastInfo(ts('point_in_room_err', 'pointInRoomErr'));
      }
      preventMod = true;
    }
    else if (AnyLineIntersectsSelfMod()) {
      preventMod = true;

    }
    else if (testRes = AnyLineIntersectsARoomMod(), testRes) {
      if (PlannerGlobals.mode == 'modifyOuterW' || testRes.wasBorder) {
        toastInfo(ts('p_ow_intersect_o_err', "Walls can't intersect rooms."));
      }
      else {
        toastInfo(ts('intersect_o_err', 'intersectOErr'));
      }
      preventMod = true;
    }
    else if (uDevDOM.polygonIntersectsAnyDev(PlannerGlobals.modifiedPoly)) {
      /* if (mode != 'modifyOuterW') { */
      toastInfoSingle(ts('p_ow_intersect_d_err', "Walls can't intersect devices"), false, 'left-out-warning');
      preventMod = true;
      /* } */
    }
    else if (PlannerGlobals.mode == 'selectRoom' && roomContainsAnother(normalModroomPoly)) {
      toastInfo(ts('contain_err', 'containErr'));
      preventMod = true;
    }

    if (preventMod) {
      d.x = PlannerGlobals.dragstartState.x;
      d.y = PlannerGlobals.dragstartState.y;
      d.tx = PlannerGlobals.dragstartState.tx;
      d.ty = PlannerGlobals.dragstartState.ty;
      d3.select(this).attr("transform", function (d, i) {
        return "translate(" + [d.tx, d.ty] + ")";
      });
      redrawModifyPolyline();
    }

    //restoring default variable state
    PlannerGlobals.leftoutAlertShown = false;
    d3.select('.modifyCircles').style('visibility', 'visible');
    $('#plannerIMAGE').css('cursor', '');
    //gives focus to the rename box for convenience
    if (!isMobile && !PlannerGlobals.isInQuote) {
      $('#name-modify-input').focus();
    }
    redrawModifyCircles();

    showCurrLeftouts();
  });


  PlannerGlobals.dragWallSelectLine = d3.drag()
  .on('start', function () {
    PlannerGlobals.draggingRoomCircle = true;
    PlannerGlobals.draggingSomething = true;
  })
  .on('drag', function (event, d) {
    d.t[0] += event.dx;
    d.t[1] += event.dy;
    d3.select(this).attr("transform", function (d) {
      return "translate(" + d.t + ")";
    });

    if (d.type == 'start') {
      PlannerGlobals.wallSelectStartPos = [d.pos[0] + d.t[0], d.pos[1] + d.t[1]];
      correctPos(PlannerGlobals.wallSelectStartPos, PlannerGlobals.wallSelectEndPos);
    } else if (d.type == 'end') {
      PlannerGlobals.wallSelectEndPos = [d.pos[0] + d.t[0], d.pos[1] + d.t[1]];
      correctPos(PlannerGlobals.wallSelectEndPos, PlannerGlobals.wallSelectStartPos);
    }

    redrawWallSelectLine();
  })
  .on('end', function (event, d) {
    var xdif, ydif;
    if (d.type == 'start') {
      xdif = d.pos[0] + d.t[0] - PlannerGlobals.wallSelectStartPos[0];
      ydif = d.pos[1] + d.t[1] - PlannerGlobals.wallSelectStartPos[1];
    }
    else if (d.type == 'end') {
      xdif = d.pos[0] + d.t[0] - PlannerGlobals.wallSelectEndPos[0];
      ydif = d.pos[1] + d.t[1] - PlannerGlobals.wallSelectEndPos[1];
    }
    var newT = [d.t[0] - xdif, d.t[1] - ydif];
    d3.select(this).attr("transform", function (d) {
      return "translate(" + newT + ")";
    });

    d.t[0] = d.t[0] - xdif;
    d.t[1] = d.t[1] - ydif;

    PlannerGlobals.draggingRoomCircle = false;
    PlannerGlobals.draggingSomething = false;
    PlannerGlobals.wallInput.attr('class', '');
    setTimeout(function () {
      if (!PlannerGlobals.isInQuote) {
        $('#wallSelectCenterInput input').trigger('select');
      }
    });
  });


  PlannerGlobals.editPictureHelper = {
    pictPos: { x: 0, y: 0 },
    pictScale: 1,
    pictRot: 0,
    pictUrl: null,
    loadNewUrl: function (url) {
      PlannerGlobals.editPictureHelper.pictUrl = url;
      PlannerGlobals.editPictureHelper.pictPos = { x: 0, y: 0 };
      PlannerGlobals.editPictureHelper.pictScale = 1;
      PlannerGlobals.editPictureHelper.pictRot = 0;
    },
    renderAll: function () {
      d3.select('#editedPicture').attr('transform', PlannerGlobals.editPictureHelper.getTransform());
      PlannerGlobals.editPictureHelper.showStats();
    },
    resetAll: function () {
      PlannerGlobals.editPictureHelper.pictPos.x = PlannerGlobals.editPictureHelper.pictPos.y = 0;
      PlannerGlobals.editPictureHelper.pictScale = 1;
      PlannerGlobals.editPictureHelper.pictRot = 0;
      PlannerGlobals.editPictureHelper.renderAll();
    },
    showStats: function () {
      $('#crop-rot-val').text(PlannerGlobals.editPictureHelper.pictRot + "°");
      $('#crop-zoom-val').text(Math.floor(PlannerGlobals.editPictureHelper.pictScale * 100) + "%");
    },
    dragPictureStarted: function (event) {
      if (event.sourceEvent.which === 1) {
        PlannerGlobals.panDisable = true;
        dragging = true;
      }
    },
    dragPicture: function (event, d) {
      if (event.sourceEvent.which === 1) {
        d.x += event.dx;
        d.y += event.dy;
        d3.select('#editedPicture').attr('transform', PlannerGlobals.editPictureHelper.getTransform());
      }
    },
    dragPictureEnd: function (event) {
      if (event.sourceEvent.which === 1) {
        PlannerGlobals.panDisable = false;
        dragging = false;
      }
    },
    changePictureRot: function (angle) {
      angle = angle % 360;
      if (angle < 0) {
        angle = 360 + angle;
      }
      PlannerGlobals.editPictureHelper.pictRot = angle;
      PlannerGlobals.editPictureHelper.renderAll();
    },
    changePictureScale: function (scale) {
      var prevScale = PlannerGlobals.editPictureHelper.pictScale;
      PlannerGlobals.editPictureHelper.pictScale = uMath.clamp(scale, 0.1, 10);

      var diffWidth = 900 * (PlannerGlobals.editPictureHelper.pictScale - prevScale);
      PlannerGlobals.editPictureHelper.pictPos.x -= diffWidth / 2;
      PlannerGlobals.editPictureHelper.pictPos.y -= diffWidth / 2;

      PlannerGlobals.editPictureHelper.renderAll();
    },
    decreaseScale: function () {
      PlannerGlobals.editPictureHelper.changePictureScale(PlannerGlobals.editPictureHelper.pictScale - 0.01);
    },
    increaseScale: function () {
      PlannerGlobals.editPictureHelper.changePictureScale(PlannerGlobals.editPictureHelper.pictScale + 0.01);
    },
    decreaseRotation: function () {
      PlannerGlobals.editPictureHelper.changePictureRot(PlannerGlobals.editPictureHelper.pictRot - 1);
    },
    increaseRotation: function () {
      PlannerGlobals.editPictureHelper.changePictureRot(PlannerGlobals.editPictureHelper.pictRot + 1);
    },
    getTransform: function () {
      var d = PlannerGlobals.editPictureHelper;
      return `translate(${d.pictPos.x},${d.pictPos.y})scale(${d.pictScale})rotate(${d.pictRot} 450 450)`;
    },
    modalLastOpenProps: {
      name: "",
      headroom: 0
    },
    restoreModalProps: function () {
    },
    insertPicture: function () {
      // TODO: moveplannercode not sure that this is needed
      // PlannerGlobals.editPictureHelper.modalLastOpenProps.name = PlannerGlobals.$modFloorModal.find('input[name="floor_name"]').val();
      // PlannerGlobals.editPictureHelper.modalLastOpenProps.headroom = PlannerGlobals.$modFloorModal.find('input[name="headroom"]').val();

      var hiderSize = 2000;

      var mask = PlannerGlobals.svg.append('mask')
      .attr('id', 'editMask')
      .attr('class', 'edit-elem');

      mask.append('rect')
        .attr('x', -hiderSize)
        .attr('y', -hiderSize)
        .attr('width', 2 * hiderSize + 900)
        .attr('height', 2 * hiderSize + 900)
        .attr('fill', "white");
      mask.append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', 900)
        .attr('height', 900)
        .attr('fill', "black");

      PlannerGlobals.container.append('rect')
        .attr('id', 'editHider')
        .attr('class', 'edit-elem')
        .attr('x', -hiderSize)
        .attr('y', -hiderSize)
        .attr('width', 2 * hiderSize + 900)
        .attr('height', 2 * hiderSize + 900)
        .attr('fill', "black")
        .attr('mask', "url(#editMask)")
        .style('opacity', 0.5);

      PlannerGlobals.container.insert("svg:image", '#plannerIMAGE + *')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', 900)
        .attr('height', 900)
        .attr('xlink:href', PlannerGlobals.editPictureHelper.pictUrl)
        .attr('id', "editedPicture")
        .attr('class', 'edit-elem')
        .style('opacity', 1)
        .datum(PlannerGlobals.editPictureHelper.pictPos)
        .call(pictureDragBehavior)

      PlannerGlobals.editPictureHelper.renderAll();
    },
    renderToBlob: function (blobCallback) {
      if (!PlannerGlobals.editPictureHelper.pictUrl) {
        console.warn("No edited picture found.");
        return;
      }

      if (typeof blobCallback !== "function") {
        console.warn("No callback given");
        return;
      }

      var srcImg = new Image();
      srcImg.src = PlannerGlobals.editPictureHelper.pictUrl;

      srcImg.onload = function () {
        var mimeType = srcImg.src.match(/jpe?g/) ? "image/jpeg" : "image/png";

        var eph = PlannerGlobals.editPictureHelper;
        var canvasSize = Math.max(srcImg.width, srcImg.height);
        if (canvasSize > 8000) {
          canvasSize = 8000;
        }

        // canvas-to-canvas ratio
        var ccRatio = canvasSize / 900;

        var canvas = document.createElement('canvas');
        canvas.width = canvas.height = canvasSize;
        var ctx = canvas.getContext('2d');

        if (mimeType === "image/jpeg") {
          ctx.save();
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, canvasSize, canvasSize);
          ctx.restore();
        }

        // get the x,y for fitting to center
        var fitCenterScale = Math.min(canvas.width / srcImg.width, canvas.height / srcImg.height);
        var x = (canvas.width / 2) - (srcImg.width / 2) * fitCenterScale;
        var y = (canvas.height / 2) - (srcImg.height / 2) * fitCenterScale;

        // translate the image
        ctx.translate(eph.pictPos.x * ccRatio, eph.pictPos.y * ccRatio)

        // scale the image
        ctx.scale(eph.pictScale, eph.pictScale);

        // rotate the image
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(degToRad(PlannerGlobals.editPictureHelper.pictRot));
        ctx.translate(-canvas.width / 2, -canvas.height / 2);

        // draw transformed img
        ctx.drawImage(srcImg, x, y, srcImg.width * fitCenterScale, srcImg.height * fitCenterScale);


        canvas.toBlob(function (blob) {
          if (blob) {
            if (blob.size < 10000000 || mimeType === "image/png") {
              blobCallback(blob, mimeType);
            }
            else {
              canvas.toBlob(function (blob2) {
                blobCallback(blob2, mimeType);
              }, "image/jpeg", 0.8);
            }
          }
        }, mimeType);
      }
    },
  }


  pictureDragBehavior = d3.drag()
  .subject(function (event, d) {
    return {
      x: d.x,
      y: d.y
    };
  })
  .on("start", PlannerGlobals.editPictureHelper.dragPictureStarted)
  .on("drag", PlannerGlobals.editPictureHelper.dragPicture)
  .on("end", PlannerGlobals.editPictureHelper.dragPictureEnd);



  /**
   * Defines the behavior of the SVG element's panning/dragging
   */
  PlannerGlobals.dragNoteBehavior = d3.drag()
  .subject(function (event, d) {
    return {
      x: d.x,
      y: d.y
    };
  })
  .on("start", dragNoteStarted)
  .on("drag", dragNote)
  .on("end", dragNoteEnd);


  $(document).on('click', '#planner-overlay', function (e) {
    $('#device_tree').addClass('highlighted');
    if (plannerOverlayTimeout) {
      clearTimeout(plannerOverlayTimeout);
    }
    plannerOverlayTimeout = setTimeout(() => {
      $('#device_tree').removeClass('highlighted');
    }, 1000);
  });

  setMode['wizard'] = PLANNER_WIZARD.wizardMode;
  cleanupMethods.push(PLANNER_WIZARD.cleanupWizard);

  PlannerGlobals.dragOuterWallCircle = d3.drag()
  .on('start', function (event, d) {
    // Midpoint detection: insert point into polygon before drag begins
    if (d.wallIndex !== undefined) {
      var wallIndex = d.wallIndex;
      PlannerGlobals.modifiedOuterWalls.splice(wallIndex + 1, 0, d);
      delete d.wallIndex;
      drawOuterWallModifyPolyline();
    }
    if (d.tx == undefined) {
      d.tx = 0;
      d.ty = 0;
    }
    PlannerGlobals.dragstartState.x = d.x;
    PlannerGlobals.dragstartState.y = d.y;
    PlannerGlobals.dragstartState.tx = d.tx;
    PlannerGlobals.dragstartState.ty = d.ty;
  })
  .on('drag', function (event, d) {
    d.x += event.dx;
    d.y += event.dy;
    d.tx += event.dx;
    d.ty += event.dy;
    d3.select(this).attr("transform", function (d, i) {
      return "translate(" + [d.tx, d.ty] + ")";
    });
    drawOuterWallModifyPolyline();
  })
  .on('end', function () {
    drawOuterWallModifyCircles();
  });
}

/**
 * renders the structure of the SVG, initalizes events, variables
 */
export function initCanvas(
    floorId,
    callback,
    failCallback,
    projectId,
    userRoleInProject,
    getFloorRoomsAndRelatedObjectsResponse,
    onCustomItemDrop,
    onReplaceDevice,
    onBulkDeleteDevice,
    onSelectDevice,
    onEditFrame,
    onChangeDesign,
    onFrameAction,
    onNoteDrop,
    onNoteEdit,
    onNoteEditOnDevice,
    onNoteAddToDevice,
    onSelectRoom,
    onScaleSaved,
    onFullscreenChange,
) {
  PlannerGlobals.plannerIsLoaded = false;
  PlannerGlobals.isInQuote = $('.quote-upper-container').length > 0 || $(
      '.quote-wrapper').length > 0 || isSecretPlanner();
  if (PlannerGlobals.lastCalculatedOuterWallTimeout) {
    clearTimeout(PlannerGlobals.lastCalculatedOuterWallTimeout);
  }
  if (!PlannerGlobals.isInQuote) {
    toastRemoveAll();
  }
  WIFICALC.reset();
  removeWifiHeatmap();
  PlannerGlobals.plannerOpacity = 0.7;
  PlannerGlobals.lastCalculatedOuterWallTimeout = null;
  //initializing variables
  PlannerGlobals.mouseDownTranslate = [0, 0];
  PlannerGlobals.mouseDownPageXY = {x: 0, y: 0};
  PlannerGlobals.serialConnections = [];
  PlannerGlobals.outerBorder = [];
  PlannerGlobals.modifiedOuterWalls = [];
  PlannerGlobals.outerWallIds = [];
  PlannerGlobals.toolbarIdStates = {};
  UDevGlobals.cachedDevices = {};
  UDevGlobals.serialIdMap = {};
  PlannerGlobals.clipboard = {};
  PlannerGlobals.LIGHTING_CALC = new LightingCalcTransfer();
  PlannerGlobals.LIGHTING_CALC.setFPSLimit(10);
  PlannerGlobals.hsvIndexes = {};
  PlannerGlobals.sliderPressed = false;
  PlannerGlobals.prevTranslate = [0, 0];
  PlannerGlobals.translatevar = [0, 0];
  PlannerGlobals.hasDraggedDev = false;
  PlannerGlobals.hasDraggedNote = false;
  PlannerGlobals.scalevar = 1;
  PlannerGlobals.prevScale = 1;
  PlannerGlobals.symbols_on = false;
  PlannerGlobals.notes_on = true;
  PlannerGlobals.rooms = [];
  PlannerGlobals.devices = [];
  PlannerGlobals.measurements = [];
  PlannerGlobals.wallModConnections = [];
  PlannerGlobals.groups = [];
  PlannerGlobals.serials = [];
  UDevGlobals.devIdSerialCache = {};
  UDevGlobals.devIsChangingTo = {};
  UDevGlobals.devIsChangingToObj = {};
  UDevGlobals.devJustChangingInGroup = {};
  PlannerGlobals.lastCalculatedOuterWall = null;
  PlannerGlobals.entitySelectClosestPt = null;
  PlannerGlobals.entitySelectClosestPts = null;
  PlannerGlobals.entitySelectStartRoom = null;
  PlannerGlobals.entitySelectPreventOnce = false;
  GroupingGlobals.groupRecalcTimeouts = {};
  GroupingGlobals.groupRecalcAgainAfter = {};
  GroupingGlobals.groupRecalcInProgress = {};
  PlannerGlobals.isZooming = false;
  PlannerGlobals.AUTOPAN_OVER_INVALID = false;
  PlannerGlobals.GHOST_DEV_PARAMS = null;
  PlannerGlobals.serverConfirmedRatioPoints = null;
  PlannerGlobals.plannerIsRemovingDevices = false;
  PlannerGlobals.DRAG_HELPER = {};
  if (PlannerGlobals.drawPanInterval) {
    clearInterval(PlannerGlobals.drawPanInterval);
  }
  $(document).off('mousemove mousedown mouseup', setPageXY);
  PlannerGlobals.wifibtn_exists = !!document.getElementById('wificalc-btn');
  var stepSlider = document.getElementById('size-slider');

  PlannerGlobals.plannerProjectId = projectId;
  PlannerGlobals.plannerFloorId = floorId;
  PlannerGlobals.userRoleInProject = userRoleInProject;

  var viewBox = getViewBoxElem($('#floor_bg'));
  if (PlannerGlobals.PLANNER_ZEN_MODE) {
    zenModeOn();
  }

  //creating the main svg
  PlannerGlobals.svg = d3.select("#svgAndChat").append("svg")
  .attr('viewBox', viewBox)
  .attr("width", '100%')
  .attr("height", plannerCanvasHeight())
  .attr("id", "plannerSVG")
  .attr("class", "midshadow")
  .attr("data-floorid", floorId);

  if (!PlannerGlobals.isInQuote) {
    PlannerGlobals.svg.on('mousemove', function (event) {
      PlannerGlobals.XY = d3.pointer(event, this);
      draw_mouseMove();
      draw_groupMeMove();
      draw_measureMeMove();
      rotateMeUpdate();
      wallSelectUpdate();
      entitySelectUpdate();
      if (event) {
        PlannerGlobals.drawd3e = event;
      }
    })
    .on("mousedown", function (event) {
      setPageXY(event);
      plannerSVGMouseDownHandler(event);
      if (event.which == 3 ||
          PlannerGlobals.draggingSomething ||
          ControllerGlobals.currentlyDraggedDevice ||
          PlannerGlobals.entitySelectStartPos ||
          measureHelper.sourceCenter ||
          PlannerGlobals.panDisable ||
          PlannerGlobals.mode == 'groupMe' ||
          PlannerGlobals.mode == 'rotateMe') {
        event.stopImmediatePropagation();
      }
    })
    .on("wheel", function (e) {
      if (isCurrentlyAutoPanning()) {
        PlannerGlobals.container.transition();
        PlannerGlobals.container.interrupt();
        if (PlannerGlobals.zoomAnimFrame) {
          cancelAnimationFrame(PlannerGlobals.zoomAnimFrame);
        }
      }
      if (PlannerGlobals.mode === "editPicture") {
        if (MODKEYS_STATE.shift) {
          if (e.deltaY > 0) {
            PlannerGlobals.editPictureHelper.decreaseRotation();
          } else {
            PlannerGlobals.editPictureHelper.increaseRotation();
          }
          e.stopImmediatePropagation();
          e.preventDefault();
        } else if (MODKEYS_STATE.ctrl) {
          if (e.deltaY > 0) {
            PlannerGlobals.editPictureHelper.decreaseScale();
          } else {
            PlannerGlobals.editPictureHelper.increaseScale();
          }
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }
    })
    .call(PlannerGlobals.zoom)
    .on("dblclick.zoom", null);
  }

  var currSvg = d3.select("#plannerSVG");

  PlannerGlobals.container = PlannerGlobals.svg.append("g").attr("id",
      "containerSVG");
  PlannerGlobals.container.append('g').attr("id", "notes");
  PlannerGlobals.roomContainer = d3.select("body").append("div");

  var src = $('#floor_bg').attr('src');

  var fullhost = getFrontendURL() + '/';

  src = src ? src.replace('../', fullhost) : '';

  $('#zen-mode-on-btn').attr('title',
      ts('full_screen_on', 'Enter full screen'));
  $('#zen-mode-off-btn').attr('title',
      ts('full_screen_off', 'Exit full screen'));
  $('#zen-mode-on-btn i').attr('class', FULL_SCREEN_ON_ICON);
  $('#zen-mode-off-btn i').attr('class', FULL_SCREEN_OFF_ICON);
  zenModeOff();

  PlannerGlobals.container.append("svg:image")
  .attr("x", 0)
  .attr("y", 0)
  .attr("width", 900)
  .attr("height", 900)
  .attr("xlink:href", src)
  .attr("id", "plannerIMAGE");

  PlannerGlobals.container.append("svg:image")
  .attr("x", 0)
  .attr("y", 0)
  .attr("width", 900)
  .attr("height", 900)
  .attr("xlink:href", fullhost + 'images/grid_big.svg')
  .attr("opacity", "40%")
  .attr("class", "gridImageClass")
  .attr("id", "gridImage");

  fetchInitData(getFloorRoomsAndRelatedObjectsResponse, function fetchSuccess() {

    var projId = PlannerGlobals.plannerProjectId;
    if (canModifyProjectByProjectId(projId)) {
      $('#planner-buttons-left-main').removeClass(
          'planner-buttons-disable-some');
    }

    if (!isPlannerVisible() || floorId != PlannerGlobals.plannerFloorId) {
      if (typeof failCallback === "function") {
        failCallback();
      }
      return;
    }

    redrawRooms();
    rebuildWallsCache(null, true, true);
    recalcBaseDevSize(); // recalc includes redrawDevices
    initGlobalEvents(
        onCustomItemDrop,
        onReplaceDevice,
        onBulkDeleteDevice,
        onSelectDevice,
        onEditFrame,
        onFrameAction,
        onChangeDesign,
        onNoteDrop,
        onNoteEdit,
        onNoteEditOnDevice,
        onNoteAddToDevice,
        onSelectRoom,
        onScaleSaved,
        onFullscreenChange
    );
    adjustCenter();
    redrawNotes();

    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      PlannerGlobals.sizeErrorHelper.badFromBeginning = true;
      $('#planner-undo-btn').add('planner-button-disabled');
    }

    try {
      // create slider
      noUiSlider.create(stepSlider, {
        start: [100 / PlannerGlobals.planner_maxZoom],
        step: 2,
        range: {
          'min': [100 / PlannerGlobals.planner_maxZoom],
          'max': [100]
        }
      });

      // slider change event handler
      stepSlider.noUiSlider
      .on('slide', function () {
        var oldscale = PlannerGlobals.scalevar;
        var number = parseInt(stepSlider.noUiSlider.get());
        number = number * PlannerGlobals.planner_maxZoom / 100;
        PlannerGlobals.scalevar = number;
        var changeTime = Math.abs(Math.round(((number - oldscale) / 0.1)));
        if (oldscale < PlannerGlobals.scalevar) {
          PlannerGlobals.translatevar[0] -= (41 * changeTime);
          PlannerGlobals.translatevar[1] -= (49 * changeTime);

        } else if (oldscale > PlannerGlobals.scalevar) {
          PlannerGlobals.translatevar[0] += (41 * changeTime);
          PlannerGlobals.translatevar[1] += (49 * changeTime);
        }

        PlannerGlobals.svg.call(
            PlannerGlobals.zoom.transform,
            d3.zoomIdentity
              .translate(PlannerGlobals.translatevar[0], PlannerGlobals.translatevar[1])
              .scale(PlannerGlobals.scalevar)
        );
        PlannerGlobals.prevTranslate = PlannerGlobals.translatevar;
        PlannerGlobals.prevScale = PlannerGlobals.scalevar;
      });
      stepSlider.noUiSlider
      .on('start', function () {
        PlannerGlobals.sliderPressed = true;
      });
      stepSlider.noUiSlider
      .on('end', function () {
        PlannerGlobals.sliderPressed = false;
      });
    } catch (err) {
      console.debug('Caught error while trying to create Zoom Slider', err);
    }

    //set initial mode
    setMode.basic();

    if (!PlannerGlobals.isInQuote) {
      $('#svgAndChat').attr('tabindex', 0).focus();
    }

    if (plannerOpenedDeferred) {
      plannerOpenedDeferred.resolve();
    }

    var bgImg = document.getElementById('floor_bg');
    var virtualImg = new Image();
    virtualImg.src = src;
    virtualImg.onload = function () {
      var vb = getViewBoxElem(virtualImg);
      if (PlannerGlobals.isInQuote) {
        PlannerGlobals.quoteViewBoxCache[floorId] = vb;
      }
      var tar = PlannerGlobals.isInQuote ? d3.selectAll(
          '.quote-floorSVG[data-floorid="' + floorId + '"]') : currSvg;
      tar.attr("viewBox", vb);
    }

    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      highlightNextProblematic();
      if (!PlannerGlobals.isInQuote) {
        toastInfo(ts('p_err_fix_please', "Please fix the errors first."));
      }
    } else {
      highlightPoint(450, 450, 1);
      instantCalcOuter();
    }

    PlannerGlobals.editPictureHelper.loadNewUrl(null);

    devicesChanged();
    abolishInvalidGroups();
    PlannerGlobals.plannerIsLoaded = true;

    $('#svgAndChat').css('opacity', '');

    // TODO: moveplannercode: probably unnecessary
    // refreshDevicesFromServer(
    //     PlannerGlobals.plannerProjectId);

    if (typeof callback === "function") {
      callback();
    }
  }, function fetchFail() {
    if (floorId != PlannerGlobals.plannerFloorId) {
      if (typeof failCallback === "function") {
        failCallback();
      }
      return;
    }
    $('#zen-mode-btn').click(function (e) {
      toggleZenMode();
    });

    $('#delete-floor-btn').click(function (e) {
      if (PlannerGlobals.mode == 'basic') {
        deleteFloor();
      } else {
        setMode.basic();
      }
    });
  });
}

export function fetchInitData(response, callback, failCallback) {
  var startFloorId = PlannerGlobals.plannerFloorId;
  getAuthHeader(function (header) {
        if (startFloorId != PlannerGlobals.plannerFloorId) {
          if (typeof failCallback === "function") {
            failCallback();
          }
          return;
        }

        PlannerGlobals.plannerHistoryManager = new PlannerHistoryManager();

        uDev.OUTDOORS_ROOM_ID = +response.floor_outdoor_room_id || -500;

        /* $(`[data-id="${uDev.OUTDOORS_ROOM_ID}"][data-type="room-del"]`).hide(); */

        var outdoorRoom = response.rooms.find(function (room) {
          return room.id === uDev.OUTDOORS_ROOM_ID;
        });

        if (outdoorRoom) {
          uDev.OUTDOORS_ROOM_NAME = outdoorRoom.roomname;
          uDev.OUTDOORS_ROOM_PROTOTYPE = outdoorRoom;
          if (Array.isArray(outdoorRoom.poly) && outdoorRoom.poly.length
              === 4) {
            uDev.OUTDOORS_ROOM_POLY = outdoorRoom.poly;
          } else {
            uDev.OUTDOORS_ROOM_POLY = [{x: 0, y: 0,}, {x: 0, y: 900,},
              {x: 900, y: 900,}, {x: 900, y: 0,}]
          }
        }

        const unassignedRoom = response.rooms.find(x => x.room_type_id == 13);
        if (unassignedRoom) {
          uDev.UNASSIGNED_ROOM_ID = unassignedRoom.id;
          uDev.UNASSIGNED_ROOM_NAME = unassignedRoom.roomname;
        }

        PlannerGlobals.rooms = response.rooms
        .filter(function (room) {
          return room.id !== uDev.OUTDOORS_ROOM_ID && room.id
              !== uDev.UNASSIGNED_ROOM_ID;
        })
        .map(function (room) {
          var span = $('<span></span>');
          span.html(room.roomname);
          room.roomname = span.text();
          room.poly = convertPoly(room.poly);
          room.room_headroom = +room.room_headroom;
          return room;
        });
        PlannerGlobals.devices = response.devices;

        var custom_items = response.room_user_custom_items.map(function (dev) {
          dev.deviceId = "C_" + dev.id;
          dev.item_type = "custom_item";
          return dev;
        });
        downloadImages(custom_items);

        PlannerGlobals.devices = PlannerGlobals.devices.concat(custom_items);

        PlannerGlobals.devices.forEach(function (device) {
          device.x = +device.x;
          device.y = +device.y;
          device.roomId = +device.roomId;
          device.angle = device.rotate_value;
          if (device.product_name_id) {
            const treeDevice = deviceProvider.getDeviceByProductNameId(device.product_name_id);
            if (treeDevice) {
              device.has_design = treeDevice.has_design;
            }
          }
          if (device.note_message) {
            device.noteId = device.default_note_id;
            device.noteTxt = device.note_message;
            device.noteColor = "#fffcc9";
            device.hasNote = true;
          }
        });

        PlannerGlobals.notes = response.postits.filter(function (postit) {
          return postit.plan_object_id === null;
        }).map(function (note) {
          return {
            note_id: note.id,
            x: note.x,
            y: note.y,
            text: note.note,
            color: note.color
          };
        });

        response.postits.filter(function (postit) {
          return postit.plan_object_id !== null;
        })
        .forEach(function (postit) {
          var devId;
          if (postit.note_type === 2) {
            devId = postit.plan_object_id;
          } else if (postit.note_type === 3) {
            devId = 'C_' + postit.plan_object_id;
          }
          var dev = getDeviceById(devId);
          if (dev) {
            dev.hasNote = true;
            dev.noteId = postit.id;
            dev.noteTxt = postit.note;
            dev.noteColor = postit.color;
          }
        });

        PlannerGlobals.groups = response.groups;

        PlannerGlobals.serials = response.serials;

        PlannerGlobals.serialConnections = response.serial_connections /* JSON.parse(localStorage.getItem(plannerFloorId + "_SER_CONNS") || "[]") */;
        PlannerGlobals.mergedDevice = response.merged_device

        PlannerGlobals.serials.forEach(function (serial) {
          if (typeof serial.deviceIds === "object" && serial.deviceIds
              && !Array.isArray(serial.deviceIds)) {
            serial.deviceIds = Object.values(serial.deviceIds);
          }
          var firstDev = getDeviceById(serial.deviceIds[0]);
          serial.angle = firstDev.angle;
        });

        var additional = response.additional_items.map(function (item) {
          if (item.type == 'electrical cabinet') {
            item.icon = item.image = "images/tree_icons/electricalcabinet.svg";
            item.item_type = 2;
          } else {
            item.icon = item.image = "images/tree_icons/rackcabinet.svg";
            item.item_type = 1;
          }
          item.category_id = NaN;
          item.groupable = undefined;
          item.ghost = false;
          item.input = undefined;
          item.is_loxone = undefined;
          item.has_design = undefined;
          item.is_nhc = undefined;
          item.product_id = undefined;
          item.device_manufacturer = undefined;
          item.device_color = undefined;
          item.image_url = undefined;
          item.product_name_id = NaN;
          item.serializable = undefined;
          item.max_serializable = 5;
          item.mergeable = undefined;
          item.groupingProgress = undefined;
          item.deviceId = 'S_' + item.id;
          item.roomId = item.room_id;
          item.angle = item.rotate_value;
          item.x = +item.x;
          item.y = +item.y;
          return item;
        });

        PlannerGlobals.devices = PlannerGlobals.devices.concat(additional);

        PlannerGlobals.plannerOpacity = +response.planner_opacity;
        PlannerGlobals.plannerOpacityIdx = PlannerGlobals.plannerOpacities.findIndex(
            function (e) {
              return e == PlannerGlobals.plannerOpacity
            });
        if (PlannerGlobals.plannerOpacityIdx == -1) {
          PlannerGlobals.plannerOpacityIdx = 0;
          PlannerGlobals.plannerOpacity = PlannerGlobals.plannerOpacities[0];
          saveOpacity(PlannerGlobals.plannerOpacity);
        }
        if (PlannerGlobals.plannerOpacity === 100) {
          PlannerGlobals.plannerEditableWallViewEnable = true;
        } else {
          PlannerGlobals.plannerEditableWallViewEnable = false;
        }

        $('#opacity-display').html(PlannerGlobals.plannerOpacity);

        PlannerGlobals.floorHeadroom = +response.floor.headroom;

        PlannerGlobals.LENGTHOF1PX = +response.floor.length_proportion;
        PlannerGlobals.lastGoodLengthOf1Px = PlannerGlobals.LENGTHOF1PX;

        PlannerGlobals.planGridShown = !!response.floor.grid_visible
        setPlanNamesShown(!!response.floor.room_name_visible);
        toolbarSwitchSet("measure-display",
            PlannerGlobals.measurements_on ? "on" : "off");
        toolbarSwitchSet("symbolname-display",
            PlannerGlobals.symbols_on ? "on" : "off");
        toolbarSwitchSet("note-display",
            PlannerGlobals.notes_on ? "on" : "off");
        toolbarSwitchSet("motionradius-display", "off");
        toolbarSwitchSet("cameraradius-display", "off");
        toolbarSwitchSet("wifiradius-display", "off");
        toolbarSwitchSet("lighting-display", "off");
        toolbarSwitchSet("building-mat-display", "off");

        toolbarSwitchSet("show-grid",
            PlannerGlobals.planGridShown ? "on" : "off");
        // betöltéskor a kép látszódik ezért ha 0 akkor kikapcsoljuk
        if (!PlannerGlobals.planGridShown) {
          $('#gridImage').toggle()
        }

        PlannerGlobals.lastRatioPoints = {
          x1: response.floor.ratio_coordx1,
          y1: response.floor.ratio_coordy1,
          x2: response.floor.ratio_coordx2,
          y2: response.floor.ratio_coordy2,
        }
        if ((PlannerGlobals.lastRatioPoints.x1 == 0
                || !PlannerGlobals.lastRatioPoints.x1) &&
            (PlannerGlobals.lastRatioPoints.y1 == 0
                || !PlannerGlobals.lastRatioPoints.y1) &&
            (PlannerGlobals.lastRatioPoints.x2 == 0
                || !PlannerGlobals.lastRatioPoints.x2) &&
            (PlannerGlobals.lastRatioPoints.y2 == 0
                || !PlannerGlobals.lastRatioPoints.y2)) {
          PlannerGlobals.lastRatioPoints = null;
        }
        PlannerGlobals.isScaleChecked = response.floor.is_scale_checked;
        PlannerGlobals.lastGoodRatioPoints = $.extend(true, {},
            PlannerGlobals.lastRatioPoints);
        PlannerGlobals.serverConfirmedRatioPoints = $.extend(true, {},
            PlannerGlobals.lastRatioPoints);
        if (response.deviceSize) {

          // 50 ről átálítouk 25 re a méretett ez db - be is ottvan
          if (PlannerGlobals.DEVICE_SIZE_MODS[response.deviceSize]
              === undefined) {
            PlannerGlobals.DEVICE_SIZE_MOD_SERVER = PlannerGlobals.DEVICE_SIZE_MOD;
            PlannerGlobals.DEVICE_SIZE_MOD = PlannerGlobals.DEVICE_SIZE_MOD;
          } else {
            PlannerGlobals.DEVICE_SIZE_MOD_SERVER = response.deviceSize;
            PlannerGlobals.DEVICE_SIZE_MOD = response.deviceSize;
          }
        } else {
          PlannerGlobals.DEVICE_SIZE_MOD_SERVER = 100;
          PlannerGlobals.DEVICE_SIZE_MOD = 100;
        }

        resetSizeErrorHelper();

        PlannerGlobals.lastGoodScaleMod = PlannerGlobals.DEVICE_SIZE_MOD;

        showActualSizeBtn();

        MovsenGlobals.camera_props = {};
        for (const camera of response.camera_values) {
          MovsenGlobals.camera_props[camera.id] = {
            viewAngle: camera.horizontal,
            radiusCM: 500,
            startColor: 'rgba(113,180,255,1)',
            endColor: 'rgba(113,180,255,0)'
          };
        }

        var segmentRequest = $.ajax({
          headers: header,
          method: 'get',
          url: ROOT_URI + '/segment/get-segments',
          data: {
            floor_id: PlannerGlobals.plannerFloorId
          },
          success: function (resp) {
            if (resp) {
              PlannerGlobals.wallModConnections = convertWallMods(resp);
            } else {
              PlannerGlobals.wallModConnections = [];
            }
          },
          error: function () {
          },
        });

        var outerWallRequest = $.Deferred();
        PlannerGlobals.outerBorder = response.outer_wall_polies;
        outerWallRequest.resolve();

        var wizardXHR = $.ajax({
          headers: header,
          url: ROOT_URI + '/project/get-wizard-project-properties',
          method: 'POST',
          data: {
            project_id: PlannerGlobals.plannerProjectId
          },
          success: function (resp) {
            var projProps = resp.project_properties || {};
            var speakers = {
              '1': 159,
              '2': 158
            };
            PlannerGlobals.wizard_items = {
              Switch: {
                placeItemId: projProps.switch_product_name_id || 78,
              },
              Lighting: {
                placeItemId: projProps.lighting_product_name_id || 107,
                // factor: 2.5,
                // correction: 1,
              },
              Shading: {
                placeItemId: projProps.shading_product_name_id || 243,
              },
              Heating: {
                placeItemId: projProps.heating_product_name_id || 143,
                placeEveryM2: 13,
              },
              OpeningSensor: {
                placeItemId: projProps.contact_sensor_product_name_id || 474,
              },
              MotionSensor: {
                placeItemId: projProps.movement_sensor_product_name_id || 81,
                sensorDegree: 110,
              },
              Speaker: {
                placeItemId: speakers[projProps.ceiling_type] || 158,
                placeEveryM2: 15,
                placeItemIdConcrete: 159,
                placeItemIdFalse: 158
              },
              Ventilator: {
                placeItemId: projProps.ventillation_product_name_id || 274,
                placeEveryM3: 40
              },
              /* SwitchedLighting: {
                                placeItemId: pp.conventional_lighting_product_name_id || 197, // TODO: CHANGE THIS TO GET FROM SERVER
                                exactCount: 1
                            } */
            };

            switch (projProps.lighting_product_name_id) {
              case '107': // RGBW LED Spot Tree
              case '211': // LED Spot RGBW Tree Anthrazit
                PlannerGlobals.wizard_items.Lighting.factor = 3;
                PlannerGlobals.wizard_items.Lighting.correction = 1;
                break;
              case '663': // LED Ceiling Spot RGBW Tree - White
              case '664': // LED Ceiling Spot RGBW Tree - Anthracite
                PlannerGlobals.wizard_items.Lighting.factor = 4;
                PlannerGlobals.wizard_items.Lighting.correction = 1.3;
                break;

              case '225': // LOXONE LED ceiling lamp RGBW TREE antracit
              case '226': // LOXONE LED ceiling lamp RGBW TREE fehér
                //wizard_items.Lighting.placeEveryM2 = 2.5;
                PlannerGlobals.wizard_items.Lighting.factor = 15;
                PlannerGlobals.wizard_items.Lighting.correction = 1;
              default:
                PlannerGlobals.wizard_items.Lighting.factor = 2.5;
                PlannerGlobals.wizard_items.Lighting.correction = 1;
            }

            WizardGlobals.WIFI_PRODUCT_ID = projProps.wireless_lan_product_name_id
                || 363;

            var mats = resp.materials || [];

            PlannerGlobals.CURRENT_MATERIALS = {
              INNER_WALLS: mats.inner_wall_material.find(function (mat) {
                return +mat.id === +projProps.inner_wall_material;
              }),
              OUTER_WALLS: mats.outer_wall_material.find(function (mat) {
                return +mat.id === +projProps.outer_wall_material;
              }),
              WINDOWS: mats.window_material.find(function (mat) {
                return +mat.id === +projProps.window_material;
              }),
              INTERNAL_DOORS: mats.inner_door_material.find(function (mat) {
                return +mat.id === +projProps.inner_door_material;
              }),
              FRONT_DOORS: mats.front_door_material.find(function (mat) {
                return +mat.id === +projProps.front_door_material;
              }),
            };

            processMats(PlannerGlobals.CURRENT_MATERIALS);

            PlannerGlobals.CURRENT_MATERIALS.CEILING = {
              id: +projProps.ceiling_type
            };

            PlannerGlobals.comfortLevel = +projProps.comfort_level_id || 2;

            if (typeof projProps['field_of_interest'] === "object"
                && projProps['field_of_interest']) {
              switch (+projProps['field_of_interest'].id) {
                case 1:
                  PlannerGlobals.systemFieldOfInterest = "loxone";
                  break;
                case 2:
                  PlannerGlobals.systemFieldOfInterest = "conventional";
                  break;
                case 3:
                  PlannerGlobals.systemFieldOfInterest = "it";
                  break;
              }
            } else {
              console.log(
                  'field_of_interest wasnt found in wizard props response')
            }
          }
        });
        const measurePromise = $.Deferred();
        getMeasurementSystem(PlannerGlobals.plannerProjectId)
        .then(val => {
          PlannerGlobals.PLANNER_MEASUREMENT_SYSTEM = val;
        })
        .finally(() => {
          measurePromise.resolve();
        });

        $.when(segmentRequest, outerWallRequest, wizardXHR,
            measurePromise).always(function () {
          if (startFloorId != PlannerGlobals.plannerFloorId) {
            if (typeof failCallback === "function") {
              failCallback();
            }
            return;
          }
          recalcAllRoomsDynamicProps();
          PlannerGlobals.measurement_types = response.measurement_types;
          PlannerGlobals.measurements = convertMeasurements(
              response.measurements);

          PlannerGlobals.wallSegmentation = new WallSegmentation();
          PlannerGlobals.wallSegmentation.init();

          PlannerGlobals.wallSegmentation.loadFromServer(
              PlannerGlobals.plannerFloorId)
          .then(data => {
            return PlannerGlobals.wallSegmentation.loadStateFromExistingState(
                data);
          })
          .catch(() => {
            return PlannerGlobals.wallSegmentation.doCalculations();
          })
          .finally(() => {
            if (PlannerGlobals.plannerEditableWallViewEnable === true) {
              toggleEditableWallViewMode(true);
            }
            pureRecalcDevSize();
            filterInvalidDevices();
            initScaleLineInput();
            callback();
          });
        });
  });
}